var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    fill: "none",
    viewBox: "0 0 30 29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.39 12.266h-.12V9.24a3.046 3.046 0 0 0-3.041-3.042h-.425V4.905a3.044 3.044 0 0 0-3.042-3.04H5.04A3.044 3.044 0 0 0 2 4.905v19.057a3.046 3.046 0 0 0 3.042 3.033h18.184a3.045 3.045 0 0 0 3.042-3.042v-3.02h.12A1.614 1.614 0 0 0 28 19.32v-5.443a1.613 1.613 0 0 0-1.61-1.611m-1.855 11.692a1.31 1.31 0 0 1-1.31 1.31H5.042a1.31 1.31 0 0 1-1.31-1.31V4.902a1.31 1.31 0 0 1 1.31-1.31h14.721a1.31 1.31 0 0 1 1.31 1.31v1.297H7.2a.867.867 0 1 0 0 1.733h16.026a1.31 1.31 0 0 1 1.31 1.31v3.025h-1.735a4.335 4.335 0 1 0 0 8.667h1.733zm1.733-4.764h-3.467a2.6 2.6 0 0 1 0-5.2h3.467z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v29H0z"
  })))));
};
export default SvgWallet;